// Requires: gsap.min.js + ScrollTrigger.min.js
window.addEventListener('DOMContentLoaded', function () {
  const items = Array.from(document.querySelectorAll('.m-item'));
  if (!items.length) return;

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const hasGSAP = !!(window.gsap && window.ScrollTrigger);
  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;

  /**
   * Load background image for a card.
   * Simple eager load for stability.
   */
  function loadCardBg(card) {
    if (!card) return;

    const bg1 = card.querySelector('.bg1');
    const src = card.dataset.bg1;

    if (!bg1 || !src || bg1.dataset.loaded === 'true') return;

    const img = new Image();
    img.decoding = 'async';
    img.src = src;

    img.onload = function () {
      bg1.style.backgroundImage = 'url(' + src + ')';
      bg1.dataset.loaded = 'true';
    };

    img.onerror = function () {
      // Fallback: still set the image if something goes wrong
      bg1.style.backgroundImage = 'url(' + src + ')';
      bg1.dataset.loaded = 'true';
    };
  }

  // Always load the backgrounds (few items, so it's fine)
  items.forEach(loadCardBg);

  // If no GSAP or reduced motion, stop here
  if (!hasGSAP || prefersReducedMotion) {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /**
   * Decide if card is in left or right column (relative to the grid container)
   */
  function getColumnSide(card) {
    const grid = card.closest('.masonry-6x3');
    if (!grid) return 'left';

    const gridRect = grid.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();

    const gridMidX = gridRect.left + gridRect.width / 2;
    const cardMidX = cardRect.left + cardRect.width / 2;

    return cardMidX < gridMidX ? 'left' : 'right';
  }

  /**
   * Desktop animation (>= 992px):
   * - Left column: reveal left -> right
   * - Right column: reveal right -> left
   * - Scrubbed and reversible on scroll
   *
   * IMPORTANT CHANGE: no vertical "y" offset on desktop,
   * so cards can't end up slightly shifted vertically after resizes.
   */
  function initDesktopAnimation(card) {
    var fromVars;
    const side = getColumnSide(card);

    if (side === 'left') {
      // LEFT COLUMN: left → right, slide from left
      fromVars = {
        clipPath: 'inset(0 100% 0 0)', // hidden from right
        opacity: 0,
        x: -40,
        // no y here
      };
    } else {
      // RIGHT COLUMN: right → left, slide from right
      fromVars = {
        clipPath: 'inset(0 0 0 100%)', // hidden from left
        opacity: 0,
        x: 40,
        // no y here
      };
    }

    const tween = gsap.from(
      card,
      Object.assign({}, fromVars, {
        duration: 0.8,
        ease: 'power2.out',
      }),
    );

    ScrollTrigger.create({
      trigger: card,
      start: 'top 90%', // begin anim when top of card is near bottom of viewport
      end: 'top 40%', // fully revealed by the time it reaches upper-middle
      scrub: 0.8, // tie tween progress to scroll (smooth both directions)
      animation: tween,
    });
  }

  /**
   * Mobile / tablet animation (< 992px):
   * - Reveal top -> bottom
   * - Scrubbed and reversible on scroll
   */
  function initMobileAnimation(card) {
    var fromVarsMobile = {
      // inset(top right bottom left)
      // start with BOTTOM fully clipped so it reveals top -> bottom
      clipPath: 'inset(0 0 100% 0)', // hidden from bottom
      opacity: 0,
      y: 40,
    };

    const tweenMobile = gsap.from(
      card,
      Object.assign({}, fromVarsMobile, {
        duration: 0.8,
        ease: 'power2.out',
      }),
    );

    ScrollTrigger.create({
      trigger: card,
      start: 'top 90%',
      end: 'top 40%',
      scrub: 0.8,
      animation: tweenMobile,
    });
  }

  /**
   * Use ScrollTrigger.matchMedia so that:
   * - Desktop and mobile animations are set up separately.
   * - When breakpoint changes, ScrollTrigger automatically kills old triggers.
   * - We reset card inline styles each time to avoid leftover hidden/offset states.
   */
  ScrollTrigger.matchMedia({
    // Desktop
    '(min-width: 992px)': function () {
      items.forEach(function (card) {
        // Clear only the props we animate
        gsap.set(card, { clearProps: 'clipPath,opacity,x,y' });
        initDesktopAnimation(card);
      });
    },

    // Mobile / tablet
    '(max-width: 991.98px)': function () {
      items.forEach(function (card) {
        // Clear only the props we animate
        gsap.set(card, { clearProps: 'clipPath,opacity,x,y' });
        initMobileAnimation(card);
      });
    },
  });
});
